module.exports = __webpack_public_path__ + "img/矢量智能对象.6941cd3c.png";